// NeedsYou (drawing v2.6, `needs()` on the record and dashboard screens;
// standard rule 2): one amber panel at the top, drawn only when something
// needs a person. One problem per line, one button that fixes it; "N of M"
// in the header when the list is capped.

import type { ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { ItemRow } from "./ItemRow";
import { cx } from "./cx";

export interface NeedsYouItem {
  id: string;
  icon?: ReactNode;
  title: ReactNode;
  why: ReactNode;
  /** The one button that fixes it (a navy small Button). */
  action?: ReactNode;
  /** Anything else (a second, plain button). Rare. */
  more?: ReactNode;
}

export function NeedsYou({ items, total, className, title = "Needs you" }: { items: NeedsYouItem[]; /** The whole population when the list is capped ("1 of 3"). */ total?: number; className?: string; title?: ReactNode }) {
  if (items.length === 0) return null;
  const shown = items.length;
  const count = total !== undefined && total !== shown ? `${shown} of ${total}` : String(shown);
  return (
    <section className={cx("pg-card", className)} aria-label={typeof title === "string" ? title : "Needs you"}>
      <h2 className="pg-needs__h">
        <AlertTriangle className="pg-ico" aria-hidden />
        {title}
        <span>{count}</span>
      </h2>
      {items.map((it) => (
        <ItemRow key={it.id} mark={it.icon ?? <AlertTriangle className="pg-ico" aria-hidden />} markTone="warn" name={it.title} why={it.why} action={it.action} more={it.more} />
      ))}
    </section>
  );
}
